export default __webpack_public_path__ + "static/bannerbox.gsk-gebro-0a886585b0b0ff11db3cc4da8e60cecd.jpg";